// React
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from "react-router-dom";
// Helpers
import {getRoleName, isActualPlatform, isMaintenance, returnElementFromArray} from "@helpers";
// Components
import {ProfileCard} from "@components/Profile";
import {MobileInfo} from "@components/Mobile";
import {Banner, CommentsNotify} from "@components/Header";
import {SelectGrouping} from "@components/Input";
import Desktop from "./desktop";
import Mobile from "./mobile";
// Styles
import './styles.scss';
// Img
import {homeSvg} from "@assets";
import centribal_png from "@img/centribal.png";

class Container extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false
        }
    }

    onSelectProject = (e) => {
        var actual = returnElementFromArray(e, this.props.projects, 'id');
        if (actual) {
            this.props.setActualProject(actual);
        }
    }

    handleVisibility = (menu_sidebar_projects) => {
        const {history} = this.props;
        var res = true;
        ['/academy', '/campaigns'].map((el) => {
            if (history.location.pathname.includes(el)) {
                res = false;
            }
        })

        var menu = false;
        menu_sidebar_projects?.forEach(item => {
            if (item.items.length > 0) {
                menu = true;
            }
        })

        return res && menu;
    }

    handleSelectProjectItem = () => {
        const {t, actualProject} = this.props;
        if (actualProject.sandbox) {
            return <div className={"sandbox_selector"}>
                <span>{actualProject.name}</span>
                <span className={"sandbox_label"}>sandbox</span>
            </div>
        } else if (!actualProject.active) {
            return <div className={"soft_delete_selector"}>
                <span>{actualProject.name}</span>
                <span className={"soft_delete_label"}>{t(`card.content.project.selector_deleted`)}</span>
            </div>
        } else {
            return <span>{actualProject.name}</span>
        }
    }

    render() {
        const {
            user,
            actualLayout,
            actualProject,
            projects,
            plan,
            history,
            cleanSocketsTicketById,
            cleanAllSocketTickets,
            viewSocketsTicket,
            t
        } = this.props;

        const role = getRoleName(user.roles[0]),
            platform = process.env.REACT_APP_PLATFORM;

        var menu_sidebar_projects = [
            {
                group_name: "active",
                items: []
            },
            {
                group_name: "deleted",
                items: []
            }
        ];

        projects?.forEach((project) => {
            if (project.active) {
                menu_sidebar_projects[0].items.push(project);
            }
            if (role !== 'Trainer' && platform === 'centribot' && !project.active) {
                menu_sidebar_projects[1].items.push(project);
            }
        })

        return (
            <React.Fragment>
                <Banner plan={plan}/>
                <div className={"platform_header"}>
                    <div className={"platform_header_img"}>
                        <img alt="platform_icon" src={centribal_png}/>
                    </div>
                    <div className={"platform_header_content"}>
                        <Desktop
                            user={user}
                            actualLayout={actualLayout}
                            actualProject={actualProject}
                            plan={plan}
                            history={history}
                            t={t}
                        />
                        <Mobile
                            user={user}
                            actualLayout={actualLayout}
                            actualProject={actualProject}
                            plan={plan}
                            history={history}
                            t={t}
                        />
                        <div className={"platform_header_actions"}>
                            {
                                !isMaintenance(plan?.id) && isActualPlatform('centribot') && this.handleVisibility(menu_sidebar_projects) &&
                                    <div className={"platform_select_project"}>
                                        <div onClick={() => history.push("/dashboard")} className={"platform_select_project_home"}>
                                            {homeSvg()}
                                        </div>
                                        <SelectGrouping
                                            valueSelected={this.handleSelectProjectItem()}
                                            items={menu_sidebar_projects}
                                            onSelect={this.onSelectProject}
                                            placeholder={t(`commons:input.select.project.placeholder`)}
                                            type={'select_project'}
                                            value={'id'}
                                            t={t}
                                        />
                                    </div>
                            }
                            {
                                isActualPlatform('centridesk') &&
                                <CommentsNotify cleanAllSocketTickets={cleanAllSocketTickets}
                                                cleanSocketsTicketById={cleanSocketsTicketById}
                                                viewSocketsTicket={viewSocketsTicket}/>
                            }
                            <ProfileCard plan={plan} user={user}/>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}


const mapStateToProps = state => {
    return {
        data: state
    }
}

const _component = connect(
    mapStateToProps
)(Container);

export default withRouter(_component);